import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import LanguageSwitcher from "./LanguageSwitcher";
import { MAIN_SITE_URL, categories } from "@/mocks/categories";

export default function Navbar() {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-background-200">
      <nav className="flex items-center justify-between px-4 md:px-6 h-16 md:h-20">
        <Link to="/" className="flex items-center gap-2 cursor-pointer">
          <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-file-list-3-line text-lg"></i>
          </span>
          <span className="font-heading font-bold text-base md:text-lg text-foreground-950 whitespace-nowrap">
            <span className="hidden sm:inline">US Fans Spreadsheet</span>
            <span className="sm:hidden">US Fans</span>
          </span>
        </Link>

        {/* Desktop nav links */}
        <div className="hidden md:flex items-center gap-2 md:gap-3">
          <Link
            to="/"
            className="whitespace-nowrap inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm font-semibold text-foreground-800 hover:bg-background-100 hover:text-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-home-4-line"></i>
            {t("common.home")}
          </Link>
          <Link
            to="/usfans-spreadsheet-guide"
            className="whitespace-nowrap inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm font-semibold text-foreground-800 hover:bg-background-100 hover:text-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-book-open-line"></i>
            {t("common.shoppingGuide")}
          </Link>
          <LanguageSwitcher />
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="whitespace-nowrap inline-flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            {t("common.buyNow")}
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        {/* Mobile controls */}
        <div className="flex md:hidden items-center gap-2">
          <LanguageSwitcher />
          <button
            type="button"
            onClick={() => setMenuOpen((o) => !o)}
            className="w-10 h-10 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label={t("common.menu")}
            aria-expanded={menuOpen}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </nav>

      {/* Mobile menu panel */}
      {menuOpen && (
        <div className="md:hidden border-t border-background-200 bg-background-50 animate-fade-in">
          <div className="px-4 py-4 space-y-3">
            <Link
              to="/"
              onClick={() => setMenuOpen(false)}
              className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold text-foreground-900 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-home-4-line"></i>
              </span>
              {t("common.home")}
            </Link>
            <Link
              to="/usfans-spreadsheet-guide"
              onClick={() => setMenuOpen(false)}
              className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold text-foreground-900 hover:bg-background-100 transition-colors cursor-pointer"
            >
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className="ri-book-open-line"></i>
              </span>
              {t("common.shoppingGuide")}
            </Link>

            <a
              href={MAIN_SITE_URL}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-background-50/20">
                <i className="ri-shopping-cart-line"></i>
              </span>
              {t("common.buyNow")}
            </a>

            <div className="pt-3 mt-1 border-t border-background-200">
              <p className="px-3 text-xs font-semibold uppercase tracking-wide text-foreground-500">
                {t("footer.categories")}
              </p>
              <div className="mt-2 grid grid-cols-2 gap-1.5 max-h-64 overflow-y-auto">
                {categories.map((c) => (
                  <a
                    key={c.id}
                    href={c.url}
                    target="_blank"
                    rel="noopener nofollow"
                    onClick={() => setMenuOpen(false)}
                    className="rounded-md px-3 py-2 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis"
                  >
                    {t(`cat.${c.id}`)}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}